import { Grid, Typography } from "@mui/material";

import Select from "components/Select";
import { useFormContext } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

function DesktopDepositTypes({ selectedCoinTypes }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { watch, setValue } = useFormContext();
  const type = watch("type");

  const handleChangeType = (e) => {
    const val = e.target.value;
    setValue("type", val);

    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      type: val,
    });
  };

  return (
    <Grid item xs={12}>
      <Typography variant="h6" color="text.main" fontWeight={400}>
        Type
      </Typography>

      <Select
        dir="ltr"
        items={selectedCoinTypes}
        itemText="name"
        itemValue="id"
        value={type}
        onChange={handleChangeType}
      />
    </Grid>
  );
}

export default DesktopDepositTypes;
